import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const FranceLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'fr',
  LONG_NAME: 'France',
  SHORT_NAME: 'FR',
  DISPLAY_COUNTRY: 'France',
  SHOW_TIME_IN_MILITARY: true,
  LANGUAGES: {
    FR: 'fr',
    EN: 'en',
  },

  [BRAND_LIST.UQ]: {
    [Languages.FR]: {
      LANGUAGE_CODE: 'fr',
      DISPLAY_NAME: 'France (Français)',
      CONTACT_US_URL: 'https://faq-fr.uniqlo.com/',
      HOME_PAGE_URL: 'https://www.uniqlo.com/fr/fr',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/fr/fr/',
      TERMS_OF_USE_URL:
        'https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?id=kA13z000000LMbI&l=fr&c=category_uq_eu_dk_se%3ARenew_UQFR_C7_3&fs=Search&pn=1',
      PRIVACY_POLICY_URL:
        'https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?id=kA13z000000XmnT&l=fr&c=category_uq_eu_dk_se%3ARenew_UQFR_C7_2&fs=Search&pn=1',
      AREAS: {
        '1': 'Ain',
        '2': 'Aisne',
        '3': 'Allier',
        '4': 'Alpes-de-Haute-Provence',
        '5': 'Alpes-Maritimes',
        '6': 'Ardèche',
        '7': 'Ardennes',
        '8': 'Ariège',
        '9': 'Aube',
        '10': 'Aude',
        '11': 'Aveyron',
        '12': 'Bas-Rhin',
        '13': 'Bouches-du-Rhône',
        '14': 'Calvados',
        '15': 'Cantal',
        '16': 'Charente',
        '17': 'Charente-Maritime',
        '18': 'Cher',
        '19': 'Corrèze',
        '20': 'Corse-du-Sud',
        '21': "Côte-d'Or",
        '22': "Côtes-d'Armor",
        '23': 'Creuse',
        '24': 'Deux-Sèvres',
        '25': 'Dordogne',
        '26': 'Doubs',
        '27': 'Drôme',
        '28': 'Essonne',
        '29': 'Eure',
        '30': 'Eure-et-Loir',
        '31': 'Finistère',
        '32': 'Gard',
        '33': 'Gers',
        '34': 'Gironde',
        '44': 'Haut-Rhin',
        '35': 'Haute-Corse',
        '36': 'Haute-Garonne',
        '37': 'Haute-Loire',
        '38': 'Haute-Marne',
        '40': 'Haute-Saône',
        '41': 'Haute-Savoie',
        '43': 'Haute-Vienne',
        '39': 'Hautes-Alpes',
        '42': 'Hautes-Pyrénées',
        '45': 'Hauts-de-Seine',
        '46': 'Hérault',
        '47': 'Ille-et-Vilaine',
        '48': 'Indre',
        '49': 'Indre-et-Loire',
        '50': 'Isère',
        '51': 'Jura',
        '52': 'Landes',
        '56': 'Loir-et-Cher',
        '53': 'Loire',
        '54': 'Loire-Atlantique',
        '55': 'Loiret',
        '57': 'Lot',
        '58': 'Lot-et-Garonne',
        '59': 'Lozère',
        '60': 'Lyon',
        '61': 'Maine-et-Loire',
        '62': 'Manche',
        '63': 'Marne',
        '64': 'Mayenne',
        '65': 'Meurthe-et-Moselle',
        '66': 'Meuse',
        '67': 'Morbihan',
        '68': 'Moselle',
        '69': 'Nièvre',
        '70': 'Nord',
        '71': 'Oise',
        '72': 'Orne',
        '73': 'Paris',
        '74': 'Pas-de-Calais',
        '75': 'Puy-de-Dôme',
        '76': 'Pyrénées-Atlantiques',
        '77': 'Pyrénées-Orientales',
        '78': 'Rhône',
        '79': 'Saône-et-Loire',
        '80': 'Sarthe',
        '81': 'Savoie',
        '82': 'Seine-et-Marne',
        '83': 'Seine-Maritime',
        '84': 'Seine-Saint-Denis',
        '85': 'Somme',
        '86': 'Tarn',
        '87': 'Tarn-et-Garonne',
        '89': 'Territoire de Belfort',
        '88': "Val-d'Oise",
        '90': 'Val-de-Marne',
        '91': 'Var',
        '92': 'Vaucluse',
        '93': 'Vendée',
        '94': 'Vienne',
        '95': 'Vosges',
        '96': 'Yonne',
        '97': 'Yvelines',
      },
    },
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'France (English)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/fr/en',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/fr/en/',
      CONTACT_US_URL: 'https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?l=en_US',
      TERMS_OF_USE_URL:
        'https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?id=kA13z000000LMbI&l=en_US&c=category_uq_eu_dk_se%3ARenew_UQFR_C7_3&fs=Search&pn=1',
      PRIVACY_POLICY_URL:
        'https://faq-fr.uniqlo.com/pkb_Home_UQ_FR?id=kA13z000000XmnT&l=en_US&c=category_uq_eu_dk_se%3ARenew_UQFR_C7_2&fs=Search&pn=1',
      AREAS: {
        '1': 'Ain',
        '2': 'Aisne',
        '3': 'Allier',
        '4': 'Alpes-de-Haute-Provence',
        '5': 'Alpes-Maritimes',
        '6': 'Ardèche',
        '7': 'Ardennes',
        '8': 'Ariège',
        '9': 'Aube',
        '10': 'Aude',
        '11': 'Aveyron',
        '12': 'Bas-Rhin',
        '13': 'Bouches-du-Rhône',
        '14': 'Calvados',
        '15': 'Cantal',
        '16': 'Charente',
        '17': 'Charente-Maritime',
        '18': 'Cher',
        '19': 'Corrèze',
        '20': 'Corse-du-Sud',
        '21': "Côte-d'Or",
        '22': "Côtes-d'Armor",
        '23': 'Creuse',
        '24': 'Deux-Sèvres',
        '25': 'Dordogne',
        '26': 'Doubs',
        '27': 'Drôme',
        '28': 'Essonne',
        '29': 'Eure',
        '30': 'Eure-et-Loir',
        '31': 'Finistère',
        '32': 'Gard',
        '33': 'Gers',
        '34': 'Gironde',
        '44': 'Haut-Rhin',
        '35': 'Haute-Corse',
        '36': 'Haute-Garonne',
        '37': 'Haute-Loire',
        '38': 'Haute-Marne',
        '40': 'Haute-Saône',
        '41': 'Haute-Savoie',
        '43': 'Haute-Vienne',
        '39': 'Hautes-Alpes',
        '42': 'Hautes-Pyrénées',
        '45': 'Hauts-de-Seine',
        '46': 'Hérault',
        '47': 'Ille-et-Vilaine',
        '48': 'Indre',
        '49': 'Indre-et-Loire',
        '50': 'Isère',
        '51': 'Jura',
        '52': 'Landes',
        '56': 'Loir-et-Cher',
        '53': 'Loire',
        '54': 'Loire-Atlantique',
        '55': 'Loiret',
        '57': 'Lot',
        '58': 'Lot-et-Garonne',
        '59': 'Lozère',
        '60': 'Lyon',
        '61': 'Maine-et-Loire',
        '62': 'Manche',
        '63': 'Marne',
        '64': 'Mayenne',
        '65': 'Meurthe-et-Moselle',
        '66': 'Meuse',
        '67': 'Morbihan',
        '68': 'Moselle',
        '69': 'Nièvre',
        '70': 'Nord',
        '71': 'Oise',
        '72': 'Orne',
        '73': 'Paris',
        '74': 'Pas-de-Calais',
        '75': 'Puy-de-Dôme',
        '76': 'Pyrénées-Atlantiques',
        '77': 'Pyrénées-Orientales',
        '78': 'Rhône',
        '79': 'Saône-et-Loire',
        '80': 'Sarthe',
        '81': 'Savoie',
        '82': 'Seine-et-Marne',
        '83': 'Seine-Maritime',
        '84': 'Seine-Saint-Denis',
        '85': 'Somme',
        '86': 'Tarn',
        '87': 'Tarn-et-Garonne',
        '89': 'Territoire de Belfort',
        '88': "Val-d'Oise",
        '90': 'Val-de-Marne',
        '91': 'Var',
        '92': 'Vaucluse',
        '93': 'Vendée',
        '94': 'Vienne',
        '95': 'Vosges',
        '96': 'Yonne',
        '97': 'Yvelines',
      },
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 46.1106885,
    INITIAL_LONGITUDE: 2.5911028,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/fr/fr/content/Stores_Landing_France.html',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default FranceLocale
